module.exports = __webpack_public_path__ + "img/PersonalEffects.3df629e0.svg";